export const notificationsRoute = '/notifications/';
export const notificationReadRoute = '/notifications/read/';
